var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { Api, JsonRpc } from 'eosjs'; // import { SignatureProvider } from 'eosjs/dist/eosjs-api-interfaces';

var accountPublickey;
var scatter;
var signatureProvider;

if (typeof window !== undefined && typeof document !== undefined) {
  // @ts-ignore:
  scatter = window.scatter;
  document.addEventListener('scatterLoaded', function () {
    // @ts-ignore:
    scatter = window.scatter;
  });
}

function logIfDebugEnabled(msg) {
  var debug = localStorage.getItem('DEBUG');

  if (debug === 'true') {
    console.log('IN WALLET: ' + msg);
  }
}

function discover(discoveryOptions) {
  logIfDebugEnabled('The discover() method of myWallet was called'); // You probably do not need to implement this method.

  return new Promise(function (resolve, reject) {
    var discoveryInfo = {
      keys: [],
      note: 'Wallet does not support discovery'
    };
    resolve(discoveryInfo);
  });
}

function signArbitrary(data, userMessage) {
  return scatter.getArbitrarySignature(accountPublickey, data, userMessage);
}

export function tokenpocketWalletProvider() {
  return function makeWalletProvider(network) {
    // connection
    function connect(appName) {
      logIfDebugEnabled('In wallet connect');
      return new Promise(function (resolve, reject) {
        var tries = 0;

        function checkConnect() {
          logIfDebugEnabled('Checking the state of Scatter Object: ' + tries + ' : ' + scatter);
          if (scatter) return resolve(true);
          tries++;
          if (tries > 5) return reject('Cannot connect to TokenPocket wallet provider');
          setTimeout(function () {
            checkConnect();
          }, 1000);
        }

        checkConnect();
      });
    }

    function disconnect() {
      scatter.disconnect();
      return Promise.resolve(true);
    } // Authentication


    function login(accountName) {
      return __awaiter(this, void 0, void 0, function () {
        var identity, account, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logIfDebugEnabled('In login. Scatter object: ' + JSON.stringify(scatter));
              _a.label = 1;

            case 1:
              _a.trys.push([1, 3,, 4]);

              return [4
              /*yield*/
              , scatter.getIdentity({
                accounts: [__assign({}, network, {
                  blockchain: 'eos'
                })]
              })];

            case 2:
              identity = _a.sent();

              if (!identity) {
                return [2
                /*return*/
                , Promise.reject('No identity obtained from Scatter')];
              }

              account = identity && identity.accounts && identity.accounts.find(function (x) {
                return x.blockchain === 'eos';
              }) || void 0;
              logIfDebugEnabled('account2:' + account);

              if (!account) {
                return [2
                /*return*/
                , Promise.reject('No account data obtained from Scatter identity')];
              }

              accountPublickey = account.publicKey;
              logIfDebugEnabled('accountName:' + account.name);
              return [2
              /*return*/
              , {
                accountName: account.name,
                permission: account.authority,
                publicKey: accountPublickey
              }];

            case 3:
              error_1 = _a.sent();
              logIfDebugEnabled('error:' + error_1);
              console.log('[Token Pocket]', error_1);
              return [2
              /*return*/
              , Promise.reject(error_1)];

            case 4:
              return [2
              /*return*/
              ];
          }
        });
      });
    }

    function logout(accountName) {
      return scatter.forgetIdentity();
    }

    var walletProvider = {
      id: 'TokenPocket',
      meta: {
        name: 'TokenPocket',
        shortName: 'TP',
        description: 'TokenPocket is multi-chain mobile wallet that is easy and safe to use.'
      },
      signatureProvider: {
        getAvailableKeys: function getAvailableKeys() {
          return __awaiter(this, void 0, void 0, function () {
            var arr;
            return __generator(this, function (_a) {
              logIfDebugEnabled('In getAvailableKeys new1');
              logIfDebugEnabled('Return Key: ' + accountPublickey);
              arr = [accountPublickey];
              return [2
              /*return*/
              , arr];
            });
          });
        },
        sign: function sign(signatureProviderArgs) {
          return __awaiter(this, void 0, void 0, function () {
            var rpc, api;
            return __generator(this, function (_a) {
              switch (_a.label) {
                case 0:
                  logIfDebugEnabled('In Sign method');
                  if (!!signatureProvider) return [3
                  /*break*/
                  , 2];
                  logIfDebugEnabled('signatureProvider not yet created. Creating.');
                  if (!scatter.hasOwnProperty('hookProvider')) return [3
                  /*break*/
                  , 2];
                  rpc = new JsonRpc(network.protocol + '://' + network.host + ':' + network.port);
                  api = new Api({
                    rpc: rpc
                  });
                  return [4
                  /*yield*/
                  , scatter.hookProvider(network, {}, true, api)];

                case 1:
                  signatureProvider = _a.sent();
                  _a.label = 2;

                case 2:
                  return [2
                  /*return*/
                  , signatureProvider.sign(signatureProviderArgs)];
              }
            });
          });
        }
      },
      connect: connect,
      discover: discover,
      disconnect: disconnect,
      login: login,
      logout: logout,
      signArbitrary: signArbitrary
    };
    return walletProvider;
  };
}
export default tokenpocketWalletProvider;